// 2026-06-05 module spec: 三 tab→四 tab(论坛/约爱/文件/我的)
import type { ReactElement } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { cn } from '@dogdisk/shared'

type TabKey = 'forum' | 'dating' | 'files' | 'profile'

const TABS: Array<{ key: TabKey; to: string; label: string; icon: (active: boolean) => ReactElement; matches: (path: string) => boolean }> = [
  {
    key: 'forum',
    to: '/forum',
    label: '论坛',
    // '/' 重定向到 /forum(任务 11),两者都算激活
    matches: (p) => p === '/' || p === '/forum',
    icon: (a) => (
      // lucide messages-square(设计稿 GYagy tab0Icon)
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={a ? '#FF6B6B' : '#D1D5DB'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z" />
        <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" />
      </svg>
    ),
  },
  {
    key: 'dating',
    to: '/dating',
    label: '约爱',
    matches: (p) => p === '/dating',
    icon: (a) => (
      // lucide heart(设计稿 GYagy tabDateIcon;激活色同全局 #FF6B6B)
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={a ? '#FF6B6B' : '#D1D5DB'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
      </svg>
    ),
  },
  {
    key: 'files',
    to: '/files',
    label: '文件',
    matches: (p) => p.startsWith('/files') || p.startsWith('/preview') || p.startsWith('/search'),
    icon: (a) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={a ? '#FF6B6B' : '#D1D5DB'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" />
      </svg>
    ),
  },
  {
    key: 'profile',
    to: '/profile',
    label: '我的',
    matches: (p) => p.startsWith('/profile') || p.startsWith('/wallet') || p.startsWith('/vip') || p.startsWith('/orders') || p.startsWith('/messages') || p.startsWith('/tickets'),
    icon: (a) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={a ? '#FF6B6B' : '#D1D5DB'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c0-4 4-7 8-7s8 3 8 7" />
      </svg>
    ),
  },
]

export function TabBar() {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <nav
      className="fixed bottom-0 left-1/2 z-30 flex w-full max-w-[402px] -translate-x-1/2 items-center justify-around border-t border-[#F3F4F6] bg-white/95 px-4 pt-3 backdrop-blur"
      // 仅取真实 home-indicator 安全区(notched 设备 ≈34px),无安全区的设备(桌面/部分安卓)
      // 只留 12px 视觉内边距 —— 避免旧 `max(34px, …)` 在无安全区时硬撑 34px 空白。
      style={{ paddingBottom: 'max(12px, env(safe-area-inset-bottom))' }}
    >
      {TABS.map((tab) => {
        const active = tab.matches(pathname)
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => void navigate(tab.to)}
            className="flex flex-col items-center gap-1"
          >
            {tab.icon(active)}
            <span
              className={cn(
                'text-[11px] font-medium',
                active ? 'text-[#FF6B6B]' : 'text-[#D1D5DB]',
              )}
            >
              {tab.label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}
